import { Icon, NewselaSVG } from "@newsela/angelou";
import { newselaLogoAnchorCss } from "@/base/NewselaGlobalLayoutV2/NavigationBar/NewselaLogo/NewselaLogo.styles";
import * as styles from "./ExportablesTemplateHeaderSection.styles";

type ExportablesTemplateHeaderSectionProps = {
  templateTitle?: string;
  directions?: React.ReactNode;
  articleTitle?: string | undefined;
};

const ExportablesTemplateHeaderSection = ({
  templateTitle,
  directions,
  articleTitle,
}: ExportablesTemplateHeaderSectionProps) => {
  return (
    <div css={styles.headerSection}>
      <div css={styles.headerContent}>
        <Icon
          isDecorative={false}
          title="NewselaIcon"
          SvgComponent={NewselaSVG}
          __cssFor={newselaLogoAnchorCss}
        />
        <div css={styles.iconAndTitleSection}>
          <h3 css={styles.title}>{templateTitle}</h3>
          <h5 css={styles.articleTitle}>{articleTitle}</h5>
        </div>
        <div css={styles.nameClassDateSection}>
          <div css={styles.smallText}>Name</div>
          <div css={styles.nameClassDateRow}>
            <div css={styles.smallText}>Class</div>
            <div css={styles.smallText}>Date</div>
          </div>
        </div>
      </div>
      {directions}
    </div>
  );
};

export default ExportablesTemplateHeaderSection;
